export default __webpack_public_path__ + "static/plane-27ef32a3a52c2f65a7e31703e3c6b1e2.jpg";